<swiper-container [pagination]="{ clickable: true }" class="painting-details-swiper" #paintingSwiperRef>
    <swiper-slide swiperSlide *ngFor="let img of imageCarousel">
        <div>
            <img [src]="img.path" alt="">
        </div>
    </swiper-slide>
</swiper-container>
